import { SERVER_ROUTES } from '@client/routes/components/Router/routes';
import { useRouterUrl } from '@client/routes/hooks';

export const useLoginUrl = (): () => string => {
  const fullLocation = useRouterUrl();

  return () => `${SERVER_ROUTES.login}?backTo=${encodeURIComponent(fullLocation)}`;
};
